import constantURL from "./ConstantURL";
import { getStoredUserToken } from "../utils/sessionContext";

const requestPortalConsent = async (url, method) => {
  try {
    const response = await fetch(url, {
      method,
      mode: "cors",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${getStoredUserToken() || ""}`,
      },
    });

    if (!response.ok) {
      return { success: false, message: "Unable to reach the server. Please try again.", data: null };
    }

    const responseData = await response.json();
    if (responseData?.status === "success") {
      return { success: true, message: responseData.message || "", data: responseData.data ?? null };
    }

    return { success: false, message: responseData?.message || "Request failed.", data: responseData?.data ?? null };
  } catch {
    return { success: false, message: "Unable to reach the server. Please try again.", data: null };
  }
};

/** @returns {Promise<{success: boolean, message: string, data: {consentAccepted: boolean, acceptedAt: string|null}|null}>} */
export const getPortalConsentStatus = () => requestPortalConsent(constantURL.familymemberGetPortalConsentStatus, "GET");

/** @returns {Promise<{success: boolean, message: string, data: {consentAccepted: boolean, acceptedAt: string|null}|null}>} */
export const acceptPortalConsent = () => requestPortalConsent(constantURL.familymemberAcceptPortalConsent, "POST");
